import React from 'react';
import { pickDisplayedSeatCustomer, getSeatAssignedCustomers } from '../../shared/seatingTableDisplay';

const CircularTable = ({tableNumber, guests = [], inCenterCustomerIds = [], notAbsentCustomerIds = [], onSeatClick, labels = [], customerDisplayNames = {}, isFullScreen = false}) => {
	const getPositions = () => {
		const positions = [];
		const seatCount = 8;
		const radius = 60;

		for (let i=0; i< seatCount; i++) {
			const angle = ((i*360) / seatCount - 90) * (Math.PI / 180);

			const x = radius * Math.cos(angle);
			const y = radius * Math.sin(angle);

			positions.push({x, y, angle})
			
		}
		return positions;
	}

	// Full seat styling when customer is on inbound route as Picked or In Center (day route list)
	const isCustomerSolidSeat = (customerId) => {
		if (!customerId) return true; // Empty seats are not grayed out
		return inCenterCustomerIds.includes(customerId);
	}

	const seatPositions = getPositions();
	// const defaultNames = ['Guest 1', 'Guest 2', 'Guest 3', 'Guest 4', 'Guest 5', 'Guest 6', 'Guest 7', 'Guest 8' ];
	const defaultSeatNumber = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

	// This is just for test purpose
	// const guestNames = [...guests];
	// while (guestNames.length < 8) (guestNames.push(defaultNames[guestNames.length]));

	return (
		<div className="circular-table-container">
			<div className="table-circle">
				<div className="table-number">{tableNumber}</div>

				{seatPositions.map((pos, index) => {
					const guest = guests[index];
					const displayed = pickDisplayedSeatCustomer(guest, notAbsentCustomerIds);
					const assignedCount = getSeatAssignedCustomers(guest).length;
					const guestDisplayName = displayed?.customerId
						? (customerDisplayNames?.[displayed.customerId] || displayed?.customerName || '')
						: '';
					const isInCenter = isCustomerSolidSeat(displayed?.customerId);
					const hasCustomer = assignedCount > 0;
					const latestLabelColor = guest?.label?.id
						? labels.find((item) => item?.id === guest?.label?.id)?.label_color
						: undefined;
					const seatLabelColor = latestLabelColor || guest?.label?.label_color;
					
				// Determine seat style: 
				// - Apply label color if it exists
				// - Gray out if customer is assigned but not on route as picked/in-center (and no label color)
				const seatStyle = {
					...(seatLabelColor ? { background: seatLabelColor } : {}),
					...(!isInCenter && hasCustomer && !seatLabelColor ? { background: '#cccccc', opacity: 0.6 } : {}),
					...(!isInCenter && hasCustomer ? { opacity: 0.6 } : {})
				};
				// Slightly further out in fullscreen so long names do not sit on the letter; normal view stays compact
				const nameRadialOffset = isFullScreen ? 32 : 28;
				const labelOffsetX = Math.cos(pos.angle) * nameRadialOffset;
				const labelOffsetY = Math.sin(pos.angle) * nameRadialOffset;
				const guestNameStyle = {
					transform: `translate(-50%, -50%) translate(${labelOffsetX}px, ${labelOffsetY}px)`,
					...(!isInCenter && hasCustomer ? { color: '#999', fontSize: '8px' } : {})
				};
					
				return (<div className="seat-container" key={index} style={{transform: `translate(${pos.x}px, ${pos.y}px)`}}>
					<div className="guest-name" style={guestNameStyle}>
						{guestDisplayName}
					</div>
					<div 
						className={`seat-circle ${hasCustomer ? 'has-customer' : ''}`} 
						style={seatStyle}
						onClick={() => hasCustomer && onSeatClick && onSeatClick({
							...guest,
							customerId: displayed?.customerId,
							customerName: displayed?.customerName || guestDisplayName,
						})}
					>
						{defaultSeatNumber[index]}
					</div>
				</div>)
				})}
			</div>
		</div>
	)
}

export default CircularTable;